module.exports = __webpack_public_path__ + "static/media/down_triangle.0509ff50.png";